import { Controller, useFormContext } from "react-hook-form";
import { InputBaseParams } from "../Form";

/**
 * A controlled textbox input for forms
 */
const TextBox = ({
  name,
  placeholder,
  password,
  rules,
  className,
  errorClassName,
  onFocus,
  onBlur,
  type
}: InputBaseParams & {
  password?: boolean;
  placeholder?: string;
  type?: string;
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={""}
      render={({ field, fieldState: { error } }) => (
        <>
          <input
            {...field}
            onFocus={onFocus}
            onBlur={() => {
              if (onBlur) onBlur();
              field.onBlur();
            }}
            type={type || (password ? "password" : "text")}
            placeholder={placeholder}
            className={`${className} ${error && errorClassName}`}
          />
        </>
      )}
    />
  );
};

export default TextBox;
